import { values, uniq } from 'lodash';

const isFault = (outage) => outage.type === 'fault';

export const checkHttpStatus = (response) => {
  if (!response.ok) {
    const e = new Error(response.statusText);
    e.response = response;
    throw e;
  }
  return response;
};

export const getRegionStats = (region) => {
  const faults = region.stations.filter((station) => isFault(station.outage));
  const maintenances = region.stations.filter((station) => !isFault(station.outage));

  const faultCount = uniq(faults.map((fault) => fault.outageId)).length;
  const maintenanceCount = uniq(maintenances.map((maintenance) => maintenance.outageId)).length;

  return {
    faults: {
      count: faultCount,
      customers: faults.reduce((res, station) => res + station.customers, 0),
    },
    maintenances: {
      count: maintenanceCount,
      customers: maintenances.reduce((res, station) => res + station.customers, 0),
    },
  };
};

export const getRegionSummary = (regions) => {
  const summary = {
    faults: { count: 0, customers: 0 },
    maintenances: { count: 0, customers: 0 },
  };
  const faultOutageIds = [];
  const maintenanceOutageIds = [];

  values(regions).forEach((region) => region.stations.forEach((station) => {
    if (isFault(station.outage)) {
      faultOutageIds.push(station.outageId);
      summary.faults.customers += station.customers;
    } else {
      maintenanceOutageIds.push(station.outageId);
      summary.maintenances.customers += station.customers;
    }
  }));

  summary.faults.count = uniq(faultOutageIds).length;
  summary.maintenances.count = uniq(maintenanceOutageIds).length;
  return summary;
};



// WEBPACK FOOTER //
// ./src/utils/index.js